import { SectionHeader } from '../components/SectionHeader'
import { ProductCard } from '@/modules/products/ui/components/ProductCard'
import { useProducts } from '@/modules/products-api'
import type { ApiProduct } from '@/modules/products-api'
import type { Product } from '@/modules/products/model/types'

function toLegacy(p: ApiProduct): Product {
  return {
    id: p.id, slug: p.slug, name: p.name, categorySlug: p.categorySlug,
    brand: p.brand, price: p.price, oldPrice: p.oldPrice, discountPct: p.discountPct,
    image: p.image, images: p.images, rating: p.rating, reviews: p.reviews,
    inStock: p.inStock, shortDesc: p.shortDesc ?? undefined, specs: (p.specs ?? undefined),
  }
}

export function FeaturedProducts() {
  const { data, isLoading } = useProducts({ limit: 5, sort: 'popular' })

  return (
    <section>
      <SectionHeader title="Sản Phẩm Nổi Bật" viewAllTo="/danh-muc/xe-may-dien" />
      {isLoading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="aspect-[3/4] bg-slate-100 rounded-xl animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {(data?.items ?? []).map((p) => <ProductCard key={p.id} product={toLegacy(p)} />)}
        </div>
      )}
    </section>
  )
}
